import React from "react";
import styled from "styled-components";
import {
  TableRow,
  TableHeaderCell,
  TableHeader,
  TableCell,
  TableBody,
  Table,
} from "semantic-ui-react";
import { Number } from "../../../helper/functions";
import { useScreenWidth } from "../../../helper/screentWidth";
import Information from "../../Common/Information";

function Card({
  Title,
  BackgroundColor,
  Icon,
  policies,
  accounts,
  hideBenifets = false,
}) {
  const width = useScreenWidth();
  return (
    <SubContainer BackgroundColor={BackgroundColor}>
      <TopPart>
        <SubTitle>
          <img src={Icon} alt="Icon" /> {Title}
        </SubTitle>
      </TopPart>
      <BottomPart>
        {width > 755 ? (
          <CustomTable celled fixed>
            <TableHeader>
              <TableRow>
                <CustomHeader>Effective Date</CustomHeader>
                <CustomHeader>Insurer</CustomHeader>
                <CustomHeader>Policy</CustomHeader>
                <CustomHeader>Premium Frequency</CustomHeader>
                <CustomHeader>Premium</CustomHeader>
                {!hideBenifets && <CustomHeader>Benefit Amount</CustomHeader>}
                <CustomHeader>Status</CustomHeader>
                <CustomHeader>Agent</CustomHeader>
              </TableRow>
            </TableHeader>
            <CustomBody>
              {policies.map((data, index) => (
                <CustomTableRow key={index}>
                  <TableCell>
                    {data.normalized_effectivedate
                      ? new Date(
                          data.normalized_effectivedate
                        ).toLocaleDateString("en-US")
                      : ""}
                  </TableCell>
                  <TableCell>{data["normalized_insurer"] || ""}</TableCell>
                  <TableCell>{data.hip_name || ""}</TableCell>
                  <TableCell>
                    {data[
                      "hip_premiumfrequency@OData.Community.Display.V1.FormattedValue"
                    ] || ""}
                  </TableCell>
                  <TableCell>
                    {data.hip_premium ? Number(data.hip_premium) : ""}
                  </TableCell>
                  {!hideBenifets && (
                    <TableCell>
                      {data.normalized_benefitamount
                        ? Number(data.normalized_benefitamount)
                        : ""}
                    </TableCell>
                  )}
                  <TableCell>In Force</TableCell>
                  <TableCell>{data["normalized_agent"] || ""}</TableCell>
                </CustomTableRow>
              ))}
            </CustomBody>
          </CustomTable>
        ) : (
          <>
            {policies.map((data, index) => (
              <React.Fragment key={index}>
                <Information
                  bodyColor="white"
                  header={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#FBC67D" }}>Policy:</span>
                      <span>{data.hip_name || ""}</span>
                    </div>
                  }
                  body={
                    <dl
                      style={{
                        display: "grid",
                        gridTemplateColumns: "auto 1fr",
                        gap: "10px 20px",
                        maxWidth: "400px",
                      }}
                    >
                      <CustomDt>Effective Date:</CustomDt>
                      <dd>
                        <TableCell>
                          {data.normalized_effectivedate
                            ? new Date(
                                data.normalized_effectivedate
                              ).toLocaleDateString("en-US")
                            : ""}
                        </TableCell>
                      </dd>
                      <CustomDt>Insurer:</CustomDt>
                      <dd>{data["normalized_insurer"] || ""}</dd>
                      <CustomDt>Premium Frequency</CustomDt>
                      <dd>
                        {data[
                          "hip_premiumfrequency@OData.Community.Display.V1.FormattedValue"
                        ] || ""}
                      </dd>
                      <CustomDt>Premium:</CustomDt>
                      <dd>
                        {data.hip_premium ? Number(data.hip_premium) : ""}
                      </dd>
                      {!hideBenifets && <CustomDt>Benefit Amount:</CustomDt>}
                      {!hideBenifets && (
                        <dd>
                          {data.normalized_benefitamount
                            ? Number(data.normalized_benefitamount)
                            : ""}
                        </dd>
                      )}
                      <CustomDt>Status:</CustomDt>
                      <dd>Inforce </dd>
                      <CustomDt>Agent:</CustomDt>
                      <dd>{data["normalized_agent"] || ""}</dd>
                    </dl>
                  }
                />
              </React.Fragment>
            ))}
          </>
        )}
      </BottomPart>
    </SubContainer>
  );
}

// Styled Components
const SubContainer = styled.div`
  display: grid;
  padding: 20px;
  gap: 10px;
  border-radius: 20px;
  box-shadow: 0px 0px 3px 0.1px gray;
  background: ${(props) =>
    props.BackgroundColor || "rgba(251, 198, 125, 0.15)"};
`;

const TopPart = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
`;

const SubTitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  color: #304961;
  font-size: 30px;
  font-weight: 400;

  @media screen and (max-width: 719px) {
    font-size: 20px;
  }
`;

const BottomPart = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
  padding: 0 20px;
`;

const CustomTable = styled(Table)`
  border: none !important;
`;

const CustomBody = styled(TableBody)`
  background: linear-gradient(
    180deg,
    rgba(251, 198, 125, 0.5) 0%,
    rgba(251, 198, 125, 0) 100%
  ) !important;
`;

const CustomTableRow = styled(TableRow)`
  background-color: white;

  &:nth-child(even) {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;

const CustomHeader = styled(TableHeaderCell)`
  background: rgba(251, 198, 125, 0.15) !important;
  color: #304961 !important;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
`;

const CustomDt = styled.dt`
  font-weight: bold;
`;

export default Card;
